/**
 * @license
 * Copyright 2025 Qwen Team
 * SPDX-License-Identifier: Apache-2.0
 */

import type { FC } from 'react';

const MessageInput: FC = () => <div>MessageInput Component Placeholder</div>;

export default MessageInput;
